var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCmStep1Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_490_17868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.78125 0.878906H49.2188V41.5039H0.78125V0.878906Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.78125 0.878906H49.2188V7.12891H0.78125V0.878906Z",
    fill: "#9FA8DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2812 47.3633L35.6251 48.9258L32.9689 47.3633L30.3123 48.9258L27.6562 47.3633L25 48.9258L22.3438 47.3633L19.6877 48.9258L17.0311 47.3633L14.3749 48.9258L11.7188 47.3633V11.8164H32.0312L38.2812 18.0664V47.3633Z",
    fill: "#FFE082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0312 11.8164V18.0664H38.2812L32.0312 11.8164Z",
    fill: "#FF8A65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4375 24.707C23.4375 27.0802 21.5137 29.0039 19.1406 29.0039C16.7675 29.0039 14.8438 27.0802 14.8438 24.707C14.8438 22.3339 16.7675 20.4102 19.1406 20.4102C21.5137 20.4102 23.4375 22.3339 23.4375 24.707Z",
    fill: "#9FA8DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4375 37.207C23.4375 39.5802 21.5137 41.5039 19.1406 41.5039C16.7675 41.5039 14.8438 39.5802 14.8438 37.207C14.8438 34.8339 16.7675 32.9102 19.1406 32.9102C21.5137 32.9102 23.4375 34.8339 23.4375 37.207Z",
    fill: "#9FA8DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6249 3.22363H46.8749V4.78613H15.6249V3.22363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.12494 3.22363H4.68744V4.78613H3.12494V3.22363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.24994 3.22363H7.81244V4.78613H6.24994V3.22363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37494 3.22363H10.9374V4.78613H9.37494V3.22363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6454 26.9174L16.8743 25.1462L17.979 24.0407L18.6454 24.7079L20.3022 23.0508L21.4069 24.1555L18.6454 26.9174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6454 39.4506L16.8743 37.6794L17.979 36.5739L18.6454 37.2411L20.3022 35.584L21.4069 36.6887L18.6454 39.4506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5624 21.9736H35.9374V23.5361H26.5624V21.9736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5624 25.8799H32.8124V27.4424H26.5624V25.8799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5624 34.4736H35.9374V36.0361H26.5624V34.4736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5624 38.3799H32.8124V39.9424H26.5624V38.3799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.0976562V42.2852H10.9375V47.81L14.3749 49.8322L17.0311 48.2697L19.6877 49.8322L22.3438 48.2697L25 49.8322L27.6562 48.2697L30.3123 49.8322L32.9689 48.2697L35.6251 49.8322L39.0625 47.81V42.2852H50V0.0976562H0ZM37.5 46.9166L35.6251 48.0194L32.9689 46.4569L30.3123 48.0194L27.6562 46.4569L25 48.0194L22.3438 46.4569L19.6877 48.0194L17.0311 46.4569L14.3749 48.0194L12.5 46.9166V12.5977H31.25V18.8477H37.5V46.9166ZM32.8125 17.2852V13.7024L36.3953 17.2852H32.8125ZM48.4375 40.7227H39.0625V17.7429L32.3547 11.0352H10.9375V40.7227H1.5625V7.91016H48.4375V40.7227ZM48.4375 6.34766H1.5625V1.66016H48.4375V6.34766Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1406 19.6289C16.3361 19.6289 14.0625 21.9025 14.0625 24.707C14.0625 27.5116 16.3361 29.7852 19.1406 29.7852C21.9452 29.7852 24.2188 27.5116 24.2188 24.707C24.2153 21.904 21.9437 19.6323 19.1406 19.6289ZM19.1406 28.2227C17.1989 28.2227 15.625 26.6487 15.625 24.707C15.625 22.7654 17.1989 21.1914 19.1406 21.1914C21.0823 21.1914 22.6562 22.7654 22.6562 24.707C22.654 26.6479 21.0815 28.2204 19.1406 28.2227Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1406 32.1289C16.3361 32.1289 14.0625 34.4025 14.0625 37.207C14.0625 40.0116 16.3361 42.2852 19.1406 42.2852C21.9452 42.2852 24.2188 40.0116 24.2188 37.207C24.2153 34.404 21.9437 32.1323 19.1406 32.1289ZM19.1406 40.7227C17.1989 40.7227 15.625 39.1487 15.625 37.207C15.625 35.2654 17.1989 33.6914 19.1406 33.6914C21.0823 33.6914 22.6562 35.2654 22.6562 37.207C22.654 39.1479 21.0815 40.7204 19.1406 40.7227Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_490_17868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmStep1Icon);
export default __webpack_public_path__ + "static/media/cm_step1_icon.c35bed098853c6eadccf1098f1936c65.svg";
export { ForwardRef as ReactComponent };